<template>
    <div>
        <el-dialog title="查询详情" width="1800px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
                    <!-- 搜索筛选 -->
        <!-- <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="题目类型：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科目类别：">
                <el-select style="width: 100px;" size="small" v-model="formInline.subject" placeholder="请选择">
                    <el-option v-for="type in subject" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="题型：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type_question" placeholder="请选择">
                    <el-option v-for="type in type_question" :label="type.key" :value="type.value"
                        :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="编号：">
                <el-input size="small" v-model="formInline.number" placeholder="请输入编号"></el-input>
            </el-form-item>
            <el-form-item label="题目：">
                <el-input size="small" v-model="formInline.title" placeholder="请输入题目"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form> -->
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column prop="pbid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="type" label="题目类型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.type == 0">小车</div>
                    <div v-else-if="row.type == 1">货车</div>
                    <div v-else-if="row.type == 2">客车</div>
                    <div v-else>摩托车</div>
                </template>
            </el-table-column>
            <el-table-column prop="number" label="编号" width="80">
            </el-table-column>
            <el-table-column prop="subject" label="科目类别" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.subject == 0">科目一</div>
                    <div v-else>科目四</div>
                </template>
            </el-table-column>
            <el-table-column prop="type_question" label="题型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.type_question == 0">判断</div>
                    <div v-else-if="row.type_question == 1">单选</div>
                    <div v-else>多选</div>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="题目" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="title_img" label="题目图片" width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.title_img" class="table_list_pic"
                            :src="scope.row.title_img" :preview-src-list="[scope.row.title_img]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="opt" label="题目选项" width="auto" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="answer" label="题目答案" width="80">
            </el-table-column>
            <el-table-column prop="explain_official" label="官方讲解" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="explain_skill" label="技巧讲解" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="explain_skill_gif" label="技巧讲解图片" width="100">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.explain_skill_gif" class="table_list_pic"
                            :src="scope.row.explain_skill_gif" :preview-src-list="[scope.row.explain_skill_gif]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="200">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="uptexts(scope.row)"><i class="el-icon-edit" />题目修改</el-button>
                    <el-button size="mini" type="primary" @click="Uptaudio(scope.row)"><i class="el-icon-edit" />语音修改</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除关联关系</el-button>
                </template>
            </el-table-column>
        </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-dialog>
        <Uptext :info="updateInfo" :show.sync="updateDialogStatus" size="small" @refesh_list="getdata"></Uptext>

        <Uptaudio :info="updateInfos" :show.sync="uptaudioDialogStatus" size="small" @refesh_list="getdata"></Uptaudio>

    </div>
</template>
<script>
import { getclassifyInfo,delRelational,geteditVoice,getedit } from '../../api/userMG';
import Pagination from '../../components/Pagination'
import Uptaudio from './uptaudio.vue'
import Uptext from './uptext.vue'

export default {
    name: 'Add',
    components: {
        Pagination,Uptaudio,Uptext
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        userid: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            updateInfo:{},
            updateInfos:{},
            formInline: {
                pcid:''
            },
            uptaudioDialogStatus:false,
            updateDialogStatus:false,
            loading: false, //是显示加载
            listData:[],
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
        }
    },
    watch: {
        show(val) {
            if (val) {
                this.formInline.pcid = this.userid
                this.getdata()
            }
        }
    },
    methods: {
               //修改语音
         Uptaudio(row){
            geteditVoice({ pbid: row.pbid}).then(res => {
                console.log(res,'+++++++++++');
                if (res.code == 200) {
                    this.uptaudioDialogStatus = true
                    this.updateInfos = res.bank_info
                }
            })
        },
        uptexts(row) {
            getedit({ pbid: row.pbid, echo: 'get' }).then(res => {
                console.log(res,'+++++++++++');
                if (res.code == 200) {
                    this.updateDialogStatus = true
                    this.updateInfo = res.bank_info
                }
            })
        },
        open() {
            
        },
        // 搜索事件
        search() {
            this.getdata()
        },
        getdata() {
            this.loading = true
            getclassifyInfo(this.formInline).then(res => {
                this.listData = res.problem_info.data
                this.pageparm.total =res.problem_info.total
            this.loading = false

            })
        },
        del(row) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delRelational({ bcid: row.bcid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        closeForm(){
            this.$emit('update:show', false)
            this.loading = false
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        }
    }
}
</script>
<style scoped >
.dialog-footer {
    margin: 40px 0px 0px 280px;
}
</style>



// WEBPACK FOOTER //
// src/views/group/details.vue